import { User_Base, User_UpdateMyInfo_Request, User_UpdateMyInfo_Response } from '../models/User';
import { getAxiosInstance } from '../../react/utils/networkUtil';

export type IRecentData = {};
export const remote_getMyProfile = async (): Promise<User_Base> => {
  return (await getAxiosInstance({ hideSystemError: true }).get('/api/users-ext/me')).data;
};

export const mock_getRecentData = async (): Promise<Array<IRecentData>> => {
  const recent_data: IRecentData[] = [
    // {
    //     id: 1,
    //     name: 'data 1',
    //     description: 'description 1',
    //     completed: false,
    //     dueDate: 'Jul 1',
    // },
  ];

  return recent_data;
};

export const mock_updateRecentData = async (recentData: IRecentData): Promise<IRecentData> => {
  return recentData;
};

export const remote_getProfile = async (userId: number): Promise<User_Base> => {
  return (await getAxiosInstance({ hideSystemError: true }).get(`/api/users-ext/${userId}`)).data;
};

export const remote_updateProfile = async (profileData: FormData): Promise<User_UpdateMyInfo_Response> => {
  return (await getAxiosInstance().put('/api/users-ext/me', profileData)).data;
};

export const ProfileAPIs = {
  remote_getMyProfile,
  remote_getProfile,
  remote_updateProfile,
}